import {useEffect} from "react"
import {useNavigate} from "react-router-dom"

let navigate

export const setNavigate = nav => {
    navigate = nav
}

export const navigateTo = path => {
    if (navigate) {
        navigate(path)
    } else {
        console.warn("Navigate not initialized")
    }
}

const NavigationInitializer = () => {
    const navigate = useNavigate()

    useEffect(() => {
        setNavigate(navigate)
    }, [navigate])

    return null
}

export default NavigationInitializer